module.exports = __webpack_public_path__ + "img/loading_icon.568e135a.png";